/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/glass/controllers/ShareExtraActionHandler',['../../lib/@waca/core-client/js/core-client/ui/core/Class', 'bi/content_apps/common/ui/list_actions/LegacyArtifactActionHandler'], function (Class, LegacyArtifactActionHandler) {
	'use strict'; //NOSONAR

	/**
  * This Class is an action controller for Share button in folder context menu.
  */

	var ShareExtraActionHandler = Class.extend({

		init: function init() {},

		execute: function execute(context) {
			var legacyArtifactAction = new LegacyArtifactActionHandler();
			legacyArtifactAction._openUrl = function (url) {
				// store the generated url
				this.url = url;
				return url;
			}.bind(this);
			return legacyArtifactAction.doAction(context).then(function () {
				return { link: this._getUrl(this.url) };
			}.bind(this));
		},

		isVisible: function isVisible(context) {
			return context.target.itemId === 'com.ibm.bi.glass.common.shareContextual';
		},

		_getUrl: function _getUrl(url) {
			if (/^http[s]?:\/\//.test(url)) {
				return url;
			}
			return location.origin + url;
		}
	});

	return ShareExtraActionHandler;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

